import { render, staticRenderFns } from "./PaxConnect.vue?vue&type=template&id=6b723a80&scoped=true"
import script from "./PaxConnect.vue?vue&type=script&lang=js"
export * from "./PaxConnect.vue?vue&type=script&lang=js"
import style0 from "./PaxConnect.vue?vue&type=style&index=0&id=6b723a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b723a80",
  null
  
)

export default component.exports